<script>
export default {
  methods: {},
  props: {
    removable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    noHover: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {
        visible: true
    };
  },
  computed: {},
};
</script>
    
<template>
  <div class="f-thumb" :class="{ selected, 'no-hover': noHover }" v-if="visible">
    <div class="f-message"><slot></slot></div>
    <f-icon v-if="removable" class="f-close" icon="fa6-xmark" @click="visible=false"></f-icon>
  </div>
</template>

<style lang="scss" scoped>
.f-thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  background: #cedae1;
  border-radius: 24px;

  &:not(.no-hover):hover {
    outline: 1px solid #5cbab6;
  }

  &:not(.no-hover):active {
    outline: 1px solid #5cbab6;
    background: rgba(24, 144, 211, 0.25);
  }

  &.selected {
    background: #5cbab6;

    .f-message {
      color: white;
    }

    .f-close {
      color: white;
    }

    &:not(.no-hover):hover {
      background: linear-gradient(
          0deg,
          rgba(22, 22, 21, 0.1),
          rgba(22, 22, 21, 0.1)
        ),
        #5cbab6;
    }

    &:not(.no-hover):active {
      background: linear-gradient(
          0deg,
          rgba(22, 22, 21, 0.2),
          rgba(22, 22, 21, 0.2)
        ),
        #5cbab6;
    }
  }

  .f-message {
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
  }

  .f-close {
    margin-left: 12px;
    font-weight: 500;
    font-size: 12px;
    cursor: pointer;
  }
}
</style>